// extracted by mini-css-extract-plugin
export default {"saveButton":"WorkShopOverviewConfig_saveButton__gxhST"};